export enum UuidType {
	NIL = "00000000-0000-0000-0000-000000000000",
	LAST = "ffffffff-ffff-ffff-ffff-ffffffffffff",
	GHOST = "ffffffff-ffff-ffff-ffff-ffffffffffff",
}